import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../Store";

const ContactPageButton = () => {
  const { casesStore } = useStore();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const label = t("title");

  if (!casesStore.isCaseLoaded || !label.trim()) return null;
  return (
    <button type="button"
      className={`contact-page-button-${casesStore.brand}-${i18n.language}`}
      onClick={() => navigate("/contact")}>
      <span className="header-logo-second" />
      <span className={`header-contact-entry product-font-${casesStore.brand}`}>
        {label}
      </span>
    </button>
  );
};

export default observer(ContactPageButton);
